<template>
  <nav
    v-if="auth.student"
    class="
      relative z-30 flex w-full select-none items-center justify-start gap-6 pb-6 pr-container-mobile-level-1
      pt-9 text-lg
      teacher:text-violet-text
      student:text-white
      md:pr-container-desktop-level-2
    "
    role="navigation"
  >
    <div
      class="
        shrink-0.5 grow-0 pl-container-mobile-level-1
        md:basis-container-desktop-level-4 md:pl-container-desktop-level-2
      "
    >
      <DynLink
        :to="auth.homepage"
        aria-label="Dashboard"
        class="
          block shrink-0 grow-0 ring-offset-8 ring-offset-violet-dark-500
          focus:outline-none
          focus-visible:ring-2 focus-visible:ring-focusTeacher
        "
      >
        <IconLogo
          class="h-7"
          :type="isLowerGrade ? 'invert' : 'student'"
        />
        <IconTrialLogo v-if="auth.student?.organisation?.is_trial" />
      </DynLink>
    </div>

    <ul class="text-nav-text flex gap-4 lg:gap-6 xl:gap-10">
      <li>
        <DynLink
          :to="{ name: 'StudentIndex' }"
          class="
            underline-link flex gap-2 whitespace-nowrap ring-offset-4 ring-offset-violet-dark-500
            focus:outline-none
            focus-visible:ring-2 focus-visible:ring-focusTeacher
          "
          exact-active-class="active"
          :style="`--random-offset: ${Math.random() * 100}em`"
        >
          <IconHome class="size-6 shrink-0" /> Deine Übersicht
        </DynLink>
      </li>
      <li>
        <DynLink
          :to="{ name: 'StudentPaths' }"
          class="
            underline-link flex gap-2 whitespace-nowrap ring-offset-4 ring-offset-violet-dark-500
            focus:outline-none
            focus-visible:ring-2 focus-visible:ring-focusTeacher
          "
          active-class="active"
          :style="`--random-offset: ${Math.random() * 100}em`"
        >
          <IconRoute class="size-6 shrink-0" /> LernWege
        </DynLink>
      </li>
      <li>
        <DynLink
          :to="{ name: 'StudentFeedback' }"
          :style="`--random-offset: ${Math.random() * 100}em`"
          class="
            underline-link flex gap-2 whitespace-nowrap ring-offset-4 ring-offset-violet-dark-500
            focus:outline-none
            focus-visible:ring-2 focus-visible:ring-focusTeacher
          "
          active-class="active"
        >
          <IconChat class="size-6 shrink-0" /> Rückmeldungen
        </DynLink>
      </li>
    </ul>

    <div class="ml-auto flex gap-2">
      <UiStudentIcon
        :initials="auth.student!.initials"
        :full-name="auth.student!.full_name"
        size="sm"
        class="shrink-0"
      />
      <button
        type="button"
        :style="`--random-offset: ${Math.random() * 100}em`"
        class="
          underline-link text-nav-text ring-offset-4 ring-offset-violet-dark-500
          focus:outline-none
          focus-visible:ring-2 focus-visible:ring-focusTeacher
        "
        @click="auth.logout()"
      >
        <span class="block translate-y-1"> abmelden </span>
      </button>
    </div>
  </nav>
</template>

<script setup lang="ts">
const auth = useAuthStore()
const { isLowerGrade } = useStudentSchoolYears(auth.student!)
</script>

<style lang="postcss">
.text-nav-text {
  @apply text-violet-text-negative typo-heading-m-semibold 2nd:text-white md:text-[1.25rem];

  @media (min-width: 1100px) {
    font-size: 1.375rem; /* 22px */
  }
  @media (min-width: 1180px) {
    font-size: 1.4375rem; /* 23px */
  }
  @media (min-width: 1200px) {
    font-size: 1.5rem; /* 24px */
  }
}
</style>
